import React, { useState, useEffect } from 'react'
import { FormControl } from 'react-bootstrap'
import ReactSelect, { Option } from 'react-select'

import Label from 'live/components/forms/ui/label'
import authorization from 'live/services/authorization'
import globalNotification from 'live/services/global-notification'
import i18n from 'live/services/i18n'

import { EntityEditorModal } from '../../../../../generic'
import { getOperations } from '../../../../../services'
import { IHazard, ISelectOptionType } from '../../../../../types'
import { FormField } from './style'

type IProps = {
    handleClose: () => void
    handleDescriptionChange: (k: string) => void
    handleOperationChange: (id: number, description: string) => void
    isOpen: boolean
    item: IHazard
}

export const HazardModal: React.FC<IProps> = ({
    handleClose,
    isOpen,
    item,
    handleDescriptionChange,
    handleOperationChange
}) => {
    const [operationTypes, setOperationTypes] = useState<ISelectOptionType[]>([])
    const bowtieAdmin = authorization.superAdmin || authorization.Permission.BOWTIE_ADMIN

    const handleGetOperationTypes = async (): Promise<void> => {
        try {
            const fetchOperationTypes = await getOperations()

            setOperationTypes(fetchOperationTypes.data.map(e => ({ value: e.id, label: e.description })))
        } catch (err) {
            globalNotification.error(err.message ?? i18n('An error occurred on get operations.'))
        }
    }

    useEffect(() => {
        handleGetOperationTypes()
    }, [])

    return (
        <EntityEditorModal
            handleClose={handleClose}
            isOpen={isOpen}
            borderColor="repeating-linear-gradient(45deg, #000000 0px, #000000 5px, #ffe600 5px, #ffe600 10px)"
            headerTitle={i18n('HAZARD')}
            headerSubtitle={item?.id ? '#' + item.id : ''}
        >
            <FormField>
                <Label required className="control-label">
                    {i18n('Name')}
                </Label>
                <FormControl
                    readOnly={!bowtieAdmin}
                    type="text"
                    componentClass="textarea"
                    onChange={e => handleDescriptionChange((e.target as HTMLInputElement).value)}
                    id="diagramEditor-hazardModal-field-name"
                    value={item?.name}
                    maxLength={255}
                />
            </FormField>

            <FormField>
                <Label required className="control-label">
                    {i18n('Operation')}
                </Label>
                {bowtieAdmin ? (
                    <ReactSelect
                        options={operationTypes?.map(op => ({ value: op.value, label: i18n(op.label) }))}
                        clearable={false}
                        onChange={(obj: Option<number>) => handleOperationChange(obj.value, obj.label)}
                        value={{ value: item?.operation?.id, label: i18n(item?.operation?.description) }}
                        id="diagramEditor-hazardModal-field-operation"
                    />
                ) : (
                    <FormControl
                        readOnly
                        type="text"
                        onChange={e => handleDescriptionChange((e.target as HTMLInputElement).value)}
                        id="diagramEditor-hazardModal-field-name"
                        value={i18n(item?.operation?.description)}
                        maxLength={255}
                    />
                )}
            </FormField>
        </EntityEditorModal>
    )
}
